angular
	.module 'App.Repository'

	.factory 'ProductRepository', [
		'BaseRepository', 'BACKEND_PRODUCT_ENTITY_TYPE', 'ConfigurationService', '$q',
		(BaseRepository, BACKEND_PRODUCT_ENTITY_TYPE, ConfigurationService, $q) ->
			class ProductRepository extends BaseRepository
				@resource = '/products'
				@isRestricted = true

				generateSku: ->
					@request('GET', @getUrl('/generate_sku', ''), null, @createConfig())

				findByQuery: (query = null, includeVouchers = false, productsOnly = false) ->
					if _.isEmpty(query)
						query = @createQuery()

					if !query.isSorted()
						query.sortBy 'name', 'ASC'

					query = @applyTypeCriteria(query, includeVouchers, productsOnly)

					return super(query)

				count: (query = null, includeVouchers = false) ->
					if _.isEmpty(query)
						query = @createQuery()

					query = @applyTypeCriteria(query, includeVouchers)

					return super(query)

				applyTypeCriteria: (query, includeVouchers = false, productsOnly = false) ->
					if !includeVouchers || productsOnly
						query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.SHIPPING

						if productsOnly
							query.criteria 'entity_type', '=', BACKEND_PRODUCT_ENTITY_TYPE.PRODUCT
								.or 'entity_type', '=', BACKEND_PRODUCT_ENTITY_TYPE.BUNDLE
						else if !includeVouchers
							query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.VOUCHER
							query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.TICKET

					return query

				searchAddonProducts: (searchString, existingAddons) ->
					query = do @createQuery
					criteria = query.criteria 'entity_type', '=', BACKEND_PRODUCT_ENTITY_TYPE.ADDON

					existingAddonIds = _.pluck(existingAddons, "product_id")
					criteria.and 'id', 'NOT IN', existingAddonIds.join()

					compareCriteria = @addSkuCriteria(query, searchString)
					compareCriteria.or('name', 'LIKE', searchString)

					query.setPagination 0, 10
					query.with 'product_variants'

					@findByQuery query
						.then (result) ->
							angular.forEach result.data, (product) ->
								product.name = _.escape product.name

				searchProductsForBundle: (searchString) ->
					query = @createQuery()
					query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.ADDON
					query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.BUNDLE
					query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.DEPOSIT

					compareCriteria = @addSkuCriteria(query, searchString)
					compareCriteria.or('name', 'LIKE', searchString)

					query.setPagination(0, 10)
					query.with('product_variants')

					@findByQuery (query)
						.then ((result) ->
							angular.forEach result.data, (product) ->
								product.name = _.escape product.name
						)

				getEntities: (query = null, includeVouchers = false, productsOnly = false) ->
					return @findByQuery query, includeVouchers, productsOnly
						.then (response) ->
							return response.data
						.catch ->
							return []

				countEntities: (query = null, includeVouchers = false) ->
					return @count query, includeVouchers
						.then (response) ->
							return parseInt(response.data.count)
						.catch ->
							return 0

				getEntitiesWithCount: (query = null, includeVouchers = false) ->
					return @all {count: @countEntities(query, includeVouchers), data: @getEntities(query, includeVouchers)}

				searchProductsForSuggestion: (searchString) ->
					query = @createQuery()
					query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.ADDON
					query.criteria 'entity_type', '!=', BACKEND_PRODUCT_ENTITY_TYPE.DEPOSIT

					compareCriteria = @addSkuCriteria(query, searchString)
					compareCriteria.or('name', 'LIKE', searchString)

					query.setPagination(0, @getPageSize())
					query.with('product_variants')

					return @getEntities query

				getPriceHistory: (
					productId,
					productVariantId = null,
					priceRegionId = null,
					from = null,
					to = null,
				) ->
					query = @createQuery()

					query.addParameter('product_variant_id', productVariantId)
					query.addParameter('price_region_id', priceRegionId)
					query.addParameter('from', from)
					query.addParameter('to', to)

					return super
						.findByQuery(query, "/#{productId}/price_history")
						.then((response) => response.data)

				findBySkus: (skus) ->
					query = @createQuery()
					query.addParameter('skus', skus)

					return @request('GET', @getUrl('/find_by_skus', ''), skus, @createConfig(query))
						.then (response) -> response.data

				addSkuCriteria: (query, sku) ->
					criteria = query.criteria('sku', 'LIKE', sku)

					if ConfigurationService.isEnabled('Shared.Setting.Product.MultipleSku.Enabled')
						criteria.or('product_skus>value', 'LIKE', sku)

					return criteria

				findProductSuggestions: (productId, count) ->
					query = @createQuery()
					query.addParameter('count', count)

					return super
						.findByQuery(query, "/#{productId}/suggestions/recommendations")
						.then (response) -> response.data

			return new ProductRepository
		]
